import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class NuevaFacturaService {

     constructor(private http: HttpClient) {
    
    }

    registrar(invoice_id) {
      // console.log("entramos en registrar")

      return this.http.post<any>('https://vertigofin.herokuapp.com', { invoice_id })
        .pipe(map(confirmacion => {
       
            // console.log("entramos en respuesta de registrar invoice_id")
            // console.log(confirmacion)
            return confirmacion;
        }));
    }


}